var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8748 17.3751C1.22509 17.3751 0.621368 17.0635 0.279786 16.5509C-0.0617956 16.0386 -0.0924259 15.3989 0.197898 14.8606L8.32302 0.960294C8.64053 0.371841 9.28991 0 9.99992 0C10.7099 0 11.3596 0.371841 11.6768 0.960563L19.8019 14.8608C20.0926 15.3995 20.0616 16.0392 19.7194 16.5512C19.3782 17.0637 18.7748 17.3753 18.1244 17.3753H1.8748V17.3751Z",
    fill: "#D32F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000976562C9.29002 0.000976562 8.64035 0.372818 8.32313 0.96154L0.198015 14.8618C-0.0925987 15.4004 -0.0616779 16.0401 0.279904 16.5521C0.621776 17.0647 1.22521 17.3763 1.87492 17.3763H10V0.000976562Z",
    fill: "#EF5350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78345 5.44256C8.7497 5.06437 8.98752 4.76465 9.37878 4.76465H10.6038C10.995 4.76465 11.25 5.06437 11.216 5.44256L11.1085 10.7168C11.075 11.0632 10.3316 11.2844 9.99126 11.2844C9.65064 11.2844 8.95498 11.0632 8.92095 10.7168L8.78345 5.44256ZM9.99189 12.4355C10.6891 12.4355 11.1997 12.909 11.1997 13.5238V13.6811C11.1997 14.2964 10.6891 14.7694 9.99189 14.7694C9.31126 14.7694 8.78374 14.2964 8.78374 13.6811V13.5238C8.78345 12.909 9.31126 12.4355 9.99189 12.4355Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedIcon);
export default __webpack_public_path__ + "static/media/WarningRedIcon.2f04f582.svg";
export { ForwardRef as ReactComponent };